import styled from '@emotion/styled';

const Avatar = styled('span')(({ theme }) => ({
  fontSize: theme.fonts.size.medium,
  margin: '0 1rem 0 0',
  width: '6rem',
}));

export default Avatar;
